<template>
  <div
    data-test="unit-sales-status-text"
    class="h-[35px] w-[100px]"
    @click.stop.prevent="changeStatus"
  >
    <div
      v-tooltip.top="status_display.tooltip"
      class="flex h-full items-center justify-center rounded-full"
      :class="editable ? 'cursor-pointer' : 'cursor-help'"
      :style="status_display.style"
    >
      <p class="font-semibold">
        {{ status_display.text_main }}
      </p>
    </div>
    <DealStatusModal
      :deal_prop="deal"
      :unit="unit"
      :visible_prop="set_deal_status"
      @submitDeal="emit('onUpdate')"
      @update:visible="set_deal_status = false"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import _ from 'lodash-es';
import { useI18n } from 'vue-i18n';

import { DEAL_STATUSES, DEAL_STATUSES_STYLES } from '@/app/data/model_constants';
import { DATE_FORMATS, formatWithLocale } from '@/app/util/date_fns';
import DealStatusModal from '@/app/shared_components/sales/DealStatusModal.vue';

const props = defineProps({
  deal: { type: Object, required: true },
  editable: { type: Boolean },
  unit: { type: Object, default: null },
});

const emit = defineEmits(['onUpdate']);

const set_deal_status = ref(false);

const STATUS_BACKGROUNDS = {
  [DEAL_STATUSES.SOLD]: '#effaf5',
  [DEAL_STATUSES.RESERVED]: '#eff5fb',
  [DEAL_STATUSES.LOST]: '#feecf0',
};

const { t } = useI18n();

const status_display = computed(() => {
  const status = _.get(props.deal, 'attributes.status');
  const text_main = t(`sales.labels.statuses.${status || DEAL_STATUSES.AVAILABLE}`);
  const style = {
    color: DEAL_STATUSES_STYLES[status] || DEAL_STATUSES_STYLES.available,
    'background-color': STATUS_BACKGROUNDS[status] || 'hsl(0, 0%, 96%)',
  };

  let tooltip = text_main;
  if (status === DEAL_STATUSES.SOLD) {
    const date = formatWithLocale(props.deal.attributes.sold_date, DATE_FORMATS.DAY_FMONTH_YEAR);
    tooltip = `${t('sales.labels.statuses.sold')}: ${date}`;
  } else if (status === DEAL_STATUSES.RESERVED) {
    const date = formatWithLocale(props.deal.attributes.reserved_expiry_date, DATE_FORMATS.DAY_FMONTH_YEAR);
    tooltip = `${t('sales.labels.expiry_date')}: ${date}`;
  }

  return { style, text_main, tooltip };
});

function changeStatus() {
  if (!props.editable) return;
  set_deal_status.value = true;
}
</script>
